import ChangePasswordModal from './ChangePasswordModal.vue'

export default ChangePasswordModal



// WEBPACK FOOTER //
// ./client/components/ChangePasswordModal/index.js